module.exports = __webpack_public_path__ + "img/help-icon.efac3183.svg";